module.exports = "<select  class=\"form-control input-sm\" #statusElem (change)=\"changeStatus(statusElem)\">\n    <option value=\"\">Select</option>\n    <option *ngFor=\"let item of statuses\" [value]=\"item.id\">{{item.name}}</option>\n</select>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/client-status/client-status.template.html
// module id = 1409
// module chunks = 9